import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import Tabs from "aldoo-ra/Tabs"
import { XMarkIcon } from "@heroicons/react/24/outline"
import AppDeploymentTab from "./app-deployment-tab"
import AppSettingsTab from "./app-settings-tab"
import AppStatusTab from "./app-status-tab"

const TABS = [
  { label: "Deployment", value: "deployment" },
  { label: "Settings", value: "settings" },
  { label: "Status", value: "status" },
]

const AppDetailsDialog = ({ isOpen, onClose, item }) => {
  const [tab, setTab] = useState("deployment")
  const git = item.gitState || {}
  const updates = git.updates || []
  const hasPending = git.status === "pending" && updates.length > 0

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="admin_centered"
      closeOnEscape
      closeOnClickOutside
      allowCloseBtn={false}
      styleOverrides={{
        header: "hidden",
        content: "",
        container:
          "w-full max-w-4xl max-h-full md:max-h-[calc(100vh-4rem)] bg-admin_paper overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper md:rounded-lg border border-admin_bordered shadow-xl mx-4",
      }}
    >
      <div className="p-6 space-y-4">

        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <Typography variant="admin_h3" className="leading-tight">
              {item.name}
            </Typography>
          </div>
          <div className="flex items-center gap-2 shrink-0 pt-0.5">
            <span
              className={`text-xs font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap ${
                hasPending
                  ? "text-admin_warning border-admin_warning/40 bg-admin_warning/10"
                  : "text-admin_success border-admin_success/40 bg-admin_success/10"
              }`}
            >
              {hasPending
                ? `${updates.length} update${updates.length !== 1 ? "s" : ""} available`
                : "Up to date"}
            </span>
            <button
              onClick={onClose}
              className="text-admin_text_secondary hover:text-admin_text transition-colors"
              aria-label="Close"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>

        <Tabs
          variant="admin"
          tabs={TABS}
          value={tab}
          onChange={setTab}
        />

        {tab === "deployment" && <AppDeploymentTab item={item} />}
        {tab === "status" && <AppStatusTab item={item} />}
        {tab === "settings" && <AppSettingsTab item={item} />}

      </div>
    </Modal>
  )
}

export default AppDetailsDialog
